var host = window.location.href;
var HOST;

//desenvolvimento jhon
if(host.indexOf("http://localhost:300") > -1)
{
  host = "http://localhost/foco90/v4/Foco90/api/web-services.php";
  HOST = "http://localhost/foco90/sistema/Foco90-api/";
}
//server
else{
  host = "https://api.foco90.com.br/";
  HOST = "https://api.foco90.com.br/";
}

//host = "https://api.foco90.com.br/";
//HOST = "https://api.foco90.com.br/";

const LOGIN = HOST+"ws-app/clientes/login/";
const CHECK_LOGGED = HOST+'ws-app/clientes/check-logged/';
const LOGOUT = HOST+"ws-app/clientes/logout/";

/*
  ------------------------------------------
  UPLOAD_FOTO
  ------------------------------------------
*/
const UPLOAD_FOTO = `${HOST}ws-app/upload/submit/`;

/*
  ------------------------------------------
  RECUPERAR SENHA
  ------------------------------------------
*/
const RECUPERAR_SENHA = `${HOST}ws-app/clientes/recuperar-senha/`;

/*
  ------------------------------------------
  EXERCICIOS
  ------------------------------------------
*/
const EXERCICIOS = {
  detalhe:HOST+"ws-app/exercicios/details/",
  lista: HOST+"ws-app/exercicios/to-list/"
};

/*
  ------------------------------------------
  EBOOKS
  ------------------------------------------
*/
const EBOOKS = {
  lista: `${HOST}ws-app/ebooks/load/`
};


/*
  ------------------------------------------
  BLOCOS DE PLANILHA
  ------------------------------------------
*/
const BLOCOS_PLANILHA = {
  search: HOST+"blocos-planilhas/autocomplete/",//host+"?secao=blocos_planilha_search",//
  detalhe: HOST+"blocos-planilhas/details/",
  remove: HOST+"blocos-planilhas/delete/",
  save: HOST+"blocos-planilhas/save/",
  lista: HOST+"blocos-planilhas/to-list/"
};

/*
  ------------------------------------------
  BLOCOS
  ------------------------------------------
*/
const BLOCOS = {
  search: HOST+"blocos/autocomplete/",
  detalhe: HOST+"blocos/details/",
  remove: HOST+"blocos/delete/",
  save: HOST+"blocos/save/",
  lista: HOST+"blocos/to-list/"
};

/*
  ------------------------------------------
  PLANILHAS DE TREINO
  ------------------------------------------
*/
const PLANILHAS_TREINO = {
  search: HOST+"planilhas/autocomplete/",
  detalhe: HOST+"planilhas/details/",
  lista: HOST+"planilhas/to-list/",
  remove: HOST+"planilhas/delete/",
  save: HOST+"planilhas/save/"
};

/*
  ------------------------------------------
  VIDEOS
  ------------------------------------------
*/
const VIDEOS = {
  search: HOST+"videos/autocomplete/",
  detalhe: HOST+"videos/details/",
  lista: HOST+"videos/to-list/",
  remove: HOST+"videos/delete/",
  save: HOST+"videos/save/"
};

/*
  ------------------------------------------
  PLANOS ALIMENTARES
  ------------------------------------------
*/
const PLANOS_ALIMENTARES = {
  detalhe: HOST+"ws-app/planos-alimentares/load-page/"
};

/*
  ------------------------------------------
  PLANOS
  ------------------------------------------
*/
const PLANOS = {
  detalhe: HOST+"planos/details/",
  lista: HOST+"planos/to-list/",
  remove: HOST+"planos/delete/",
  save: HOST+"planos/save/"
};

/*
  ------------------------------------------
  PERGUNTAS
  ------------------------------------------
*/
const PERGUNTAS = {
  lista: HOST+"ws-app/perguntas-frequentes/load/"
};

/*
  ------------------------------------------
  DOMICILIAR
  ------------------------------------------
*/
const DOMICILIAR = {
  detalhe: HOST+"treinos-domiciliares/details/",
  lista: HOST+"treinos-domiciliares/to-list/",
  remove: HOST+"treinos-domiciliares/delete/",
  save: HOST+"treinos-domiciliares/save/"
};

/*
  ------------------------------------------
  USUARIOS
  ------------------------------------------
*/
const USUARIOS = {
  detalhe: HOST+"usuarios/details/",
  lista: HOST+"usuarios/to-list/",
  remove: HOST+"usuarios/delete/",
  save: HOST+"usuarios/save/"
};
/*
  ------------------------------------------
  TERMOS
  ------------------------------------------
*/
const PAGINAS = {
  termos: HOST+"ws-app/termos-de-uso/",
  sobre: HOST+"ws-app/sobre/",
  ebook: HOST+"ws-app/ebook/",
  politica: HOST+"ws-app/politica-privacidade/",
};

/*
  ------------------------------------------
  UPLOADER
  ------------------------------------------
*/
const UPLOADER = HOST+"uploads/make/";

/*
  ------------------------------------------
  MENSAGENS
  ------------------------------------------
*/
const MENSAGENS = {
  lista: HOST+"ws-app/mensagens/to-list/",
  detalhe: HOST+"ws-app/mensagens/details/",
  save: HOST+"ws-app/mensagens/send/"
};

/*
  ------------------------------------------
  ACOMPANHAMENTO
  ------------------------------------------
*/
const ACOMPANHAMENTO = {
  detalhe: `${HOST}ws-app/medidas/details/`,
  save: `${HOST}ws-app/medidas/save/`,
  lista: `${HOST}ws-app/medidas/to-list/`,
  save_foto: UPLOAD_FOTO,
  remove_foto: `${HOST}ws-app/medidas/remove-photo/`
};

/*
  ------------------------------------------
  PERFIL
  ------------------------------------------
*/
const PERFIL = {
  load: `${HOST}ws-app/meus-dados/load/`,
  update: `${HOST}ws-app/meus-dados/update/`
};

/*
  ------------------------------------------
  TREINO
  ------------------------------------------
*/
const TREINO = {
  load: `${HOST}ws-app/tipo-treino/load/`,
  update: `${HOST}ws-app/tipo-treino/update/`
};

/*
  ------------------------------------------
  MEU_TREINO
  ------------------------------------------
*/
const MEU_TREINO = {
  load: `${HOST}ws-app/treinos/load/`,
  detalhe: `${HOST}ws-app/treinos/details/`,
  save_carga: `${HOST}ws-app/treinos/save-carga/`,
  imprimir: `${HOST}ws-app/treinos/imprimir/`
};

/*
  ------------------------------------------
  ENDERECO
  ------------------------------------------
*/
const ENDERECO = {
  load: `${HOST}ws-app/endereco/load/`,
  update: `${HOST}ws-app/endereco/update/`
};

/*
  ------------------------------------------
  PERFIL
  ------------------------------------------
*/
const ALTERAR_SENHA = {
  update: `${HOST}ws-app/alterar-senha/update/`
};


/*
  ------------------------------------------
  FACEBOOK
  ------------------------------------------
*/
const FACEBOOK = {
  participar: `${HOST}ws-app/clientes/participar-facebook/`
};
/*
  ------------------------------------------
  WS
  ------------------------------------------
*/
const WS = {
  perguntas: PERGUNTAS,
  uploader: UPLOADER,
  exercicios : EXERCICIOS,
  planos_alimentares: PLANOS_ALIMENTARES,
  login: LOGIN,
  paginas: PAGINAS,
  planos: PLANOS,
  domiciliar: DOMICILIAR,
  usuarios: USUARIOS,
  mensagens: MENSAGENS,
  medidas: ACOMPANHAMENTO,
  perfil: PERFIL,
  alterar_senha: ALTERAR_SENHA,
  treino: TREINO,
  endereco: ENDERECO,
  meuTreino: MEU_TREINO,
  checkLogged: CHECK_LOGGED,
  logout: LOGOUT,
  recuperar: RECUPERAR_SENHA,
  ebooks: EBOOKS,
  facebook: FACEBOOK
};

export const WS_PAGAMENTO = {
  planos: `${HOST}payment/planos/load/`,
  login: `${HOST}payment/clientes/login/`,
  signup: `${HOST}payment/clientes/signup/`,
  adesaoByCard: `${HOST}payment/cartao-credito/aderir/`,
  adesaoByBoleto: `${HOST}payment/boleto/aderir/`,
  validateUser: `${HOST}ws-app/validate/check/`,
  recuperarSenha: `${HOST}ws-app/clientes/esqueceu-senha/`
};

export default WS;



// WEBPACK FOOTER //
// ./src/config/Ws.js